import styled from 'styled-components';
import { Button, Modal } from 'antd';

export const PostureColumn = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 16px;
	flex: 1;
	min-width: 0;
	height: 100%;
`;

export const PostureDivider = styled.div`
	width: 1px;
	background-color: #d9d9d9;
	align-self: stretch;
`;

export const PostureLabel = styled.span`
	font-size: 14px;
	font-weight: 600;
	line-height: 16px;
	color: #262626;
	text-align: center;
	white-space: nowrap;
	flex-shrink: 0;
`;

export const PostureImageWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex: 1;
	width: 100%;

	svg {
		width: auto;
		height: 131px;
		max-width: 100%;
	}
`;

export const PostureImagesRow = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	gap: 0;
	flex: 1;
	width: auto;
`;

export const PostureRowDivider = styled.div<{ imageCount?: number }>`
	width: 1px;
	height: ${(props) => {
		if (props.imageCount === 2) return '100px';
		if (props.imageCount === 3) return '74px';
		return '130px';
	}};
	background-color: #d9d9d9;
	align-self: center;
`;

export const PostureImagesGrid = styled.div`
	display: grid;
	grid-template-columns: auto auto;
	grid-template-rows: auto auto;
	gap: 0;
	flex: 1;
	width: 100%;
	position: relative;
	justify-content: center;
	align-content: center;
`;

export const PostureGridDividers = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	pointer-events: none;
	width: 112.847px;
	height: 130px;

	&::before {
		content: '';
		position: absolute;
		top: 0;
		left: 50%;
		transform: translateX(-50%);
		width: 1px;
		height: 100%;
		background-color: #d9d9d9;
	}

	&::after {
		content: '';
		position: absolute;
		top: 50%;
		left: 0;
		transform: translateY(-50%);
		width: 100%;
		height: 1px;
		background-color: #d9d9d9;
	}
`;

export const PostureImageWrapperSmall = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: auto;
	margin: 0.5rem;

	svg {
		width: auto;
		height: 56px;
		max-width: 100%;
	}
`;

export const ExpandButton = styled(Button)`
	&& {
		position: absolute;
		bottom: 8px;
		right: 8px;
		padding: 8px;
		width: 32px;
		height: 32px;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #262626;
		background-color: #ffffff;
		border: 1px solid #e6e6e6;
		border-radius: 4px;

		&:hover {
			color: #2f54eb;
			border-color: #2f54eb;
		}

		.anticon {
			font-size: 16px;
		}
	}
`;

export const StyledModal = styled(Modal)`
	.ant-modal-content {
		border-radius: 12px;
		padding: 32px;
	}

	.ant-modal-header {
		padding: 0;
		margin-bottom: 24px;
		border-bottom: none;
	}

	.ant-modal-title {
		font-size: 20.825px;
		font-weight: 600;
		line-height: 23.8px;
		color: #000000;
	}

	.ant-modal-close {
		top: 32px;
		right: 32px;
		width: 32px;
		height: 32px;
		border: 1px solid #e6e6e6;
		border-radius: 4px;
		background-color: #ffffff;
		transition: all 0.3s;

		&:hover {
			border-color: #2f54eb;
			background-color: #ffffff;
		}

		.ant-modal-close-x {
			width: 32px;
			height: 32px;
			line-height: 32px;
			font-size: 16px;
			color: #262626;
		}

		&:hover .ant-modal-close-x {
			color: #2f54eb;
		}
	}

	.ant-modal-body {
		padding: 0;
	}
`;

export const ModalContent = styled.div`
	display: flex;
	flex-direction: row;
	gap: 36px;
	align-items: center;
	width: 100%;
`;

export const ModalColumn = styled.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
	align-items: center;
	flex: 1;
	min-height: 242px;

	/* Aumenta o tamanho dos SVGs na modal */
	${PostureImageWrapper} svg {
		height: 195px;
	}

	${PostureImageWrapperSmall} {
		margin: 1rem;

		svg {
			height: 85px;
		}
	}

	/* Grid mantém o mesmo tamanho na modal */
	${PostureGridDividers} {
		width: 170px;
		height: 195px;
	}
`;

export const ModalColumnLabel = styled.span`
	font-size: 20.825px;
	font-weight: 600;
	line-height: 23.8px;
	color: #262626;
	text-align: center;
	flex-shrink: 0;
`;

export const ModalDivider = styled.div`
	width: 1px;
	background-color: #d9d9d9;
	align-self: stretch;
`;
